import { LocalRepository } from '@shared/helper/local-repository';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ACCESS_TOKEN_KEY, ACCESS_TOKEN_KEY_CLIENT, REFRESH_TOKEN_KEY } from 'constants/storage-keys';

export abstract class BaseService {

    constructor(
        private repository: LocalRepository,
    ) {
    }

    public get Repository(): LocalRepository {
        return this.repository;
    }

    public getUserAccessToken() {
        return this.Repository.getCookieItem(ACCESS_TOKEN_KEY);
    }

    public getUserRefreshToken() {
        return this.Repository.getCookieItem(REFRESH_TOKEN_KEY);
    }

    public get isUserLogedIn(): boolean {
        return this.getUserAccessToken() != undefined && this.getUserAccessToken()?.length! > 0;
    }

    public getClientAccessToken() {
        return this.Repository.getCookieItem(ACCESS_TOKEN_KEY_CLIENT);
    }

    public get IsInBrowser(): boolean {
        return this.Repository.IsInBrowser;
    }

    public get getWindow(): Window {
        return this.repository.getWindow!;
    }

    public get getDocument(): Document {
        return this.Repository.getDocument;
    }

    isNullOrWhiteSpace(str: string): boolean {
        const count = str?.replace(/\s/g, '')?.length || 0;
        return count == 0;
    }

    public TermFilterParams(termFilter?: TermFilterModel) {
        let paramsValues = '';
        if (termFilter?.pgNumber || termFilter?.pgNumber == 0)
            paramsValues = `?PgNumber=${termFilter?.pgNumber}`
        if (termFilter?.pgSize)
            paramsValues = `?PgSize=${termFilter?.pgSize}`
        if ((termFilter?.pgNumber || termFilter?.pgNumber == 0) && termFilter?.pgSize)
            paramsValues = `?PgNumber=${termFilter?.pgNumber}&PgSize=${termFilter?.pgSize}`;
        if(termFilter?.searchTerm) {
            paramsValues = paramsValues.concat(`&searchTerm=${termFilter?.searchTerm}`);
        }
        return paramsValues
    }
}
